import React from 'react';
type ChipProps = {
  children: React.ReactNode;
  icon?: React.ReactNode;
  glow?: boolean;
  className?: string;
};
export function Chip({
  children,
  icon,
  glow = false,
  className = ''
}: ChipProps) {
  return <span className={`inline-flex items-center gap-2 rounded-full border border-gold/40 bg-line px-4 py-1.5 text-[12px] font-medium uppercase tracking-[0.1em] text-gold ${glow ? 'border-gold/60 shadow-[0_0_16px_rgba(255,159,28,0.3),0_0_40px_rgba(255,159,28,0.18)]' : ''} ${className}`} data-id="element-14" data-mp="1q1px9xpwqxra">
      {icon}
      {children}
    </span>;
}